import { render } from "./MenuLayout.vue?vue&type=template&id=f354f378&scoped=true"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"

import "@/assets/css/menuLayout.css?vue&type=style&index=0&id=f354f378&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f354f378"]])

export default __exports__